// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1584) return "static/chunks/a0cf267f-d4bc30e282586a99.js";
	if (chunkId === 4396) return "static/chunks/4396-56fec0589c5608e2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3505":"7aeec5c9","6294":"0af98a8b"}[chunkId] || chunkId) + "." + {"3505":"d262a82a9738d3eb","3967":"50f39e4f144279b1","5161":"a92e93ba9f4f7da3","5329":"2045183c77db731f","6294":"7cc51e8bc344955c","7662":"5d401a7e190b152a","9364":"66eb7407968c655c"}[chunkId] + ".js";
};